import Features from '../types/enums/features';
import FlavourConfig from '../config/flavours';
import ImageUtils from '../utils/image';
import User from './user';
import {
  IPlanAdvertisement,
  IPlanRequestData,
  IPlanSubscription,
} from '../types/interfaces/plan';

class Plan {
  advertisement?: IPlanAdvertisement;
  anonymous: boolean;
  badge: string;
  code: string;
  colorHex?: string;
  defaultChannel: string | null;
  features: Features[];
  id: string;
  isFree: boolean;
  incremental: boolean;
  name: string;
  price?: number;
  upgradable: boolean;
  planSubscription?: IPlanSubscription;
  recommendationsEnabled: boolean;
  shortName: string;

  constructor(plan: IPlanRequestData) {
    this.advertisement = plan.advertisement;
    this.anonymous = plan.anonymous;
    this.badge = ImageUtils.getImage(plan.badge, 'badge');
    this.code = plan.code;
    this.defaultChannel = plan.defaultChannel;
    this.features = [];
    this.id = plan.id;
    this.incremental = plan.incremental;
    this.isFree = plan.isFree;
    this.name = plan.name;
    this.price = plan.price;
    this.planSubscription = plan.planSubscription;
    this.recommendationsEnabled = plan.recommendationsEnabled ?? false;
    this.shortName = plan.name
      .toUpperCase()
      .replace(FlavourConfig.appName.toUpperCase(), '')
      .replace(' ', '');
    this.upgradable = plan.upgradable;

    if (plan.colorHex && plan.colorHex[0] !== '#') {
      this.colorHex = '#' + plan.colorHex;
    } else {
      this.colorHex = plan.colorHex;
    }
    if (plan.features?.allowRecord) {
      this.features.push(Features.ALLOW_RECORD);
    }
    if (plan.features?.channelOrdering) {
      this.features.push(Features.ORDER_CHANNELS);
    }
    if (plan.features?.lastShows) {
      this.features.push(Features.LAST_SHOWS);
    }
    if (plan.features?.p2p) {
      this.features.push(Features.P2P);
    }
    if (plan.features?.startOver) {
      this.features.push(Features.START_OVER);
    }
    if (plan.features?.timeShift) {
      this.features.push(Features.TIME_SHIFT);
    }
    if (plan.powerSaving) {
      this.features.push(Features.POWER_SAVING);
    }
  }

  evaluateFeature(feature: Features) {
    return this.features.includes(feature);
  }

  static extraPlan(id: string) {
    return User.getPlan(id);
  }

  static upgradablePlan(data: {
    _id: string;
    advertisement: IPlanAdvertisement;
    badge: string;
    colorHex: string;
    name: string;
    price?: number;
  }) {
    return new Plan({
      ...data,
      id: data._id,
      anonymous: false,
      code: '',
      defaultChannel: null,
      isFree: false,
      incremental: false,
    });
  }
}

export default Plan;
